import { all } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/src/appInsights/AppInsights';
import { saga as attachmentsSaga } from '@savgroup-front-common/core/src/domains/attachments';
import { saga as i18nSaga } from '@savgroup-front-common/core/src/domains/i18n';
import { saga as sellerConfigurationSaga } from '@savgroup-front-common/core/src/domains/sellerConfiguration';
import { sellerSaga } from '@savgroup-front-common/core/src/domains/sellers';

import { fileInfoSaga } from './fileInfo/saga';
import { saga as sellersSummarySaga } from './sellersInfo';
import { userManagementSaga } from './userManagement';
import { usersSaga } from './users';

export default function* rootSaga() {
  try {
    yield all([
      i18nSaga(),
      sellersSummarySaga(),
      sellerConfigurationSaga(),
      sellerSaga(),
      attachmentsSaga(),

      userManagementSaga(),
      usersSaga(),
      fileInfoSaga(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
